__turbopack_context__.v({
  "host": "Hosts-module-scss-module__7zYe0q__host",
  "name": "Hosts-module-scss-module__7zYe0q__name",
});
